module.exports = __webpack_public_path__ + "static/media/circleCross.8f63b8f2.svg";